import React, { Component } from "react";
import styled from "styled-components";

import kf2Logo from "../library/images/kf2-logo.png";
import kickingBrass from "../library/images/update-logo.png";
import warning from "../library/images/ESRB-warning-kf2.png";

export class Header extends Component {
  render() {
    return (
      <OuterWrapper>
        <HeaderWrapper>
          <LogoContainer>
            <div className="top-logos">
              <div className="image-container">
                <a href="https://www.killingfloor2.com/">
                  <img src={kf2Logo} alt="Killing Floor 2 Logo" />
                </a>
              </div>
              <div className="image-container">
                <img src={kickingBrass} alt="Back and Kickin' Brass Update" />
              </div>
            </div>
          </LogoContainer>
        </HeaderWrapper>
        <ESRBWrapper>
          <img src={warning} alt="ESRB: Rated Mature 17+" />
        </ESRBWrapper>
      </OuterWrapper>
    );
  }
}

const OuterWrapper = styled.div`
  margin: auto;
`;

const HeaderWrapper = styled.div`
  background-image: url("https://cosmic-s3.imgix.net/216ec780-8319-11e9-bdc7-9fa64483fe19-KF2SSKickinBrass1920x10804.jpg");
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  display: flex;
  justify-content: center;
  flex-basis: auto;
  height: 800px;
  position: relative;
  overflow: hidden;
  padding-bottom: 10px;

  .top-logos {
    display: flex;
    justify-content: space-between;
    align-items: space-around;
    flex-direction: column;
    flex-basis: auto;
    flex-wrap: wrap;
    height: 800px;
    width: 100%;
  }

  .image-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 35vw;
      margin: 0 2vw;
    }
  }

  @media (max-width: 800px) {
    height: 400px;

    .main-logo {
      width: 300px;
    }

    .image-container {
      img {
        width: 50vw;
      }
    }
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-basis: auto;
  height: 100%;
  width: 100%;
  position: absolute;
`;

const ESRBWrapper = styled.div`
  position: absolute;
  margin-top: -7.5vw;
  right: 2vw;

  img {
    width: 12vw;
  }

  @media (max-width: 650px) {
    margin-top: -8.5vw;
  }
`;

export default Header;
